import { AfterViewInit, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ApiService } from '@services/api.service';
import { UiHelper } from '@helpers/ui.helper';
import { SignalrServiceLegacy } from '@services/signalr.service.legacy';
import { Observable, of, Subscription } from 'rxjs';
import { DataHelper } from '@helpers/data.helper';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@services/translate.service';
import { LocalizationService } from '@services/localization.service';
import { WebWorkerService } from '../modules/workers/web-worker.service';
import { ChangeDetectorRef } from '@angular/core';
import { UserHelper } from '@helpers/user.helper';
import { environment } from '@environments/environment';
import { CacheService } from '@helpers/cache.helper';
import { removeUniquePipe } from '@pipes/reducer.pipe';
import uniq from 'lodash/uniq';
import { LiveStreamService } from '@services/liveStream.service';
import debounce from 'lodash/debounce';

@Component({
  selector: 'home-live',
  templateUrl: '../sharedTemplates/home-live.component.html',
})
export class HomeLiveComponent implements OnInit, AfterViewInit, OnDestroy {
  constructor(
    public _UiHelper: UiHelper,
    private _ApiService: ApiService,
    public _DataHelper: DataHelper,
    public _Router: Router,
    private _ActivatedRoute: ActivatedRoute,
    private _SignalRService: SignalrServiceLegacy,
    private _LocalizationService: LocalizationService,
    private _TranslateService: TranslateService,
    private _webWorkerService: WebWorkerService,
    private cdRef: ChangeDetectorRef,
    private _UserHelper: UserHelper,
    private cacheService: CacheService,
    private _LiveStreamService: LiveStreamService
  ) {
    this._DataHelper.getLiveFavoriteTournamentData();

    // Eğer Favori Listesinnde eleman varsa Favori Buttonunun aktifliği kontrol ediliyor
    // Bu Sayede Favori Sayfasındaki Turnuvalar takip edilebilir.
    if (this._DataHelper.liveFavoriteTournamentList.length > 0) {
      this.favoritesIsActive = this._DataHelper.getFavoritesButtonStatus();

      this.dataRebuild();
    }
  }
  public liveFilterSelectedSportId;

  oddFilterIsActive = false;
  // p1001 için Live Ekranında Single a basınca İlk live datasının EventId si yakalanıyor
  firstLiveEventId = 0;

  favoritesIsActive = false;

  liveMatchList = [];
  oldLiveMatchList = [];
  cardList = [];

  oddLiveMarketingBasketball = [0, 10, 16, 17]; // Basketball
  oddLiveMarketingTennis = [0, 10, 18, 20]; // Tennis
  oddLiveMarketingIceHockey = [0, 9, 10, 19]; // IceHockey
  oddLiveMarketingVolleyball = [0, 10, 18, 21]; // Volleyball
  oddLiveMarketingBaseball = [0, 10, 16, 17]; // Baseball
  oddLiveMarketingHandball = [0, 9, 10, 11]; // Handball
  oddLiveMarketingTableTennis = [0, 9, 10, 18]; // TableTennis

  oddLiveMarketingp1001Value = [0, 9, 8, 24];

  oddLiveMarketingValue = [0, 9, 8];
  isInitialized = false;

  matchFilterBySportKey = '';

  _selectedOdds: OddModel[] = [];
  _liveFilterItems;

  __ResultLiveData;
  contentHeight;
  othersHeight;

  isHeaderShow = true;

  fullmatch: Observable<any[]>;

  oddTypes = this._DataHelper.oddTypes;
  private subscriptionsToStopOnDestroy: Subscription[] = [];
  _fixtureUpcoming = [];
  liveSubscription;
  liveFilterSubscription;
  liveCardSubscription;

  flagSportFilter = false;

  liveFilterSelectedSportIdOld;
  isOpenLeagueMenu = true;
  isOpenSportsMenu = true;

  oddComboList: Array<LiveOddComboModel> = [
    { OddId: 0, OddNameLong: 'tipp_long', OddNameLong2: '', OddName: 'tipp', OddTitles: ['1', 'X', '2'] },
    { OddId: 9, OddNameLong: 'RestofMatch', OddNameLong2: '', OddName: 'RoM', OddTitles: ['1', 'X', '2'] },
    { OddId: 8, OddNameLong: 'NextGoal', OddNameLong2: '', OddName: 'NT', OddTitles: ['1', 'X', '2'] },
    { OddId: 10, OddNameLong: 'O/U_long', OddNameLong2: '', OddName: 'O/U', OddTitles: ['', '+', '-'] },
    { OddId: 11, OddNameLong: 'HTFirstHalf', OddNameLong2: '', OddName: 'HT', OddTitles: ['1', 'X', '2'] },
    { OddId: 11, OddNameLong: 'HTFirstHalf', OddNameLong2: '', OddName: '1x2 HT', OddTitles: ['1', 'X', '2'] },
    { OddId: 12, OddNameLong: 'NextGoal', OddNameLong2: 'OddsFirstHalf', OddName: 'NT', OddTitles: ['1', 'X', '2'] },
    { OddId: 13, OddNameLong: 'RoM HT', OddNameLong2: '', OddName: 'RoM HT', OddTitles: ['1', 'X', '2'] },
    { OddId: 14, OddNameLong: 'Ü/U 1.HZ_long', OddNameLong2: '', OddName: 'Ü/U 1.HZ', OddTitles: ['', '+', '-'] },
    { OddId: 24, OddNameLong: 'Treffenbeide?', OddNameLong2: '', OddName: 'TF?', OddTitles: ['Y', 'N'] },
  ];

  combo1SelectedOdd = this.oddComboList.find(combo => combo.OddId == 0);
  combo2SelectedOdd = this.oddComboList.find(combo => combo.OddId == 9);
  combo3SelectedOdd = this.oddComboList.find(combo => combo.OddId == 8);
  combo4SelectedOdd = this.oddComboList.find(combo => combo.OddId == 24);

  standartSingleId = 1;

  lastRebuildTime = new Date().getTime();

  timerMySlipApiCall;

  ngOnInit() {
    this.getUpcomingP1001();
    this.clearFavourites();
  }

  ngAfterViewInit() {
    if (environment.isMySlipLive) {
      this.subscriptionsToStopOnDestroy.push(
        this._DataHelper.mySlipMatchListApiCallListener.subscribe(() => {
          this.mySlipMatchListApiCall();
        })
      );

      this._DataHelper.mySlipMatchListApiCallListener.emit();
      this.timerMySlipApiCall = setInterval(() => {
        this._DataHelper.mySlipMatchListApiCallListener.emit();
      }, 1000 * 60 * 3);
    }
    // If connection is not exists
    if (!this._SignalRService.connectionExists) {
      this.subscriptionsToStopOnDestroy.push(
        this._SignalRService.connectionEstablished.subscribe(x => {
          // ////console.log("canlı bağlandı detayda : ", x);
          this.connectHub();
        })
      );
    } else {
      this.connectHub();
    }

    this.subscriptionsToStopOnDestroy.push(
      this._DataHelper.isMySlipButtonListener.subscribe(() => {
        this.dataRebuild();
      })
    );

    this.subscriptionsToStopOnDestroy.push(
      this._LiveStreamService.isOnTvButtonListener.subscribe(() => {
        this.dataRebuild();
      })
    );

    this.subscriptionsToStopOnDestroy.push(
      this._ApiService.selectedOddsEvent.subscribe(x => {
        this._selectedOdds = x as OddModel[];
      })
    );
    this._ApiService.getSelectedOdds();
    this._UiHelper.setNavbarTitle('', true, false);

    this.heightsetter(this._UiHelper.windowsHeight);
    this.subscriptionsToStopOnDestroy.push(
      this._UiHelper.windowResized.subscribe(x => {
        this.heightsetter(x.h);
      })
    );

    this.subscriptionsToStopOnDestroy.push(
      this._UiHelper.contentHeightListener.subscribe(x => {
        this.othersHeight = x;
      })
    );

    this.subscriptionsToStopOnDestroy.push(
      this._DataHelper.liveFavouriteStateChanged.subscribe(x => {
        this.dataRebuild();
      })
    );

    this.subscriptionsToStopOnDestroy.push(
      this._DataHelper.liveMatchFilterListener.subscribe(x => {
        this.dataRebuild();
      })
    );
  }

  heightsetter(c) {
    this.contentHeight = c - 252;
    this.contentHeight += 'px';
  }
  connectHub() {
    try {
      if (this.liveSubscription != undefined) {
        this.liveSubscription.unsubscribe();
      }
      if (this.liveFilterSubscription != undefined) {
        this.liveFilterSubscription.unsubscribe();
      }
      if (this.liveCardSubscription != undefined) {
        this.liveCardSubscription.unsubscribe();
      }
    } catch (e) {
      console.log(e);
    }
    this.liveSubscription = this._DataHelper.liveDataListener.subscribe(y => {
      this.oldLiveMatchList = this.liveMatchList;
      this.liveMatchList = [...y.map(i => ({ ...i, isLive: true })), ...this._fixtureUpcoming.map(i => ({ ...i, isLive: false }))];

      this.mergeLiveAndUpcoming();
    });

    this.liveMatchList = [...this._DataHelper.liveData.map(i => ({ ...i, isLive: true })), ...this._fixtureUpcoming.map(i => ({ ...i, isLive: false }))];
    this.oldLiveMatchList = this.liveMatchList;

    this.cardList = this._DataHelper.cardData;

    this.liveCardSubscription = this._DataHelper.cardDataListener.subscribe(y => {
      this.cardList = y;
    });

    this._liveFilterItems = this._DataHelper.liveFilterItems;
    this.liveFilterSubscription = this._DataHelper.liveFilterItemsListener.subscribe((x: any) => {
      const leagueFilteredData = JSON.parse(localStorage.getItem('league-filter-data'));
      if (x == null || (x.length == 0 && leagueFilteredData != null && leagueFilteredData.length > 0)) {
        this._liveFilterItems = leagueFilteredData;
        this._DataHelper.liveFilterItems = leagueFilteredData;
      } else {
        this._liveFilterItems = x;
        this._DataHelper.liveFilterItems = x;
      }
      this.dataRebuild();
    });

    this.dataRebuild();

    this.cdRef.detectChanges();

    this._SignalRService.readUpdatedEvents();

    this._UserHelper.favoriedListener.subscribe(x => {
      this.dataRebuild();
    });
  }

  mySlipMatchListApiCall() {
    this._ApiService.getMySlipsLiveMatchList().then(x => {
      if (Array.isArray(x)) {
        this._DataHelper.setMySlipMatchList(uniq(x));
      }
    });
  }

  dataRebuild() {
    this.lastRebuildTime = new Date().getTime();
    const isMySlipLive = environment.isMySlipLive;
    const isLiveStream = environment.isLiveStream;

    const wwsConfig = {
      langCode: this._LocalizationService.LANGCODE,
      isMySlipEnvironment: isMySlipLive,
      isMySlipButton: this._DataHelper.isMySlipButton,
      mySlipMatchList: this._DataHelper.mySlipMatchList,
      isLiveStreamEnvironment: isLiveStream,
      isOnTvButton: this._LiveStreamService.isOnTvButton,
      liveTvList: this._LiveStreamService.liveTvList,
      lml: this.liveMatchList,
      old_lml: this.oldLiveMatchList,
      mfbysk: this.matchFilterBySportKey,
      lfi: this._liveFilterItems,
      cardList: this.cardList,
      oddtype: this.oddLiveMarketingValue,
      favorable: this._UserHelper.favoriedMatches,
      isLive: true,
      liveSortbyTime: this._DataHelper.liveSortbyTime,
      liveFavoriteButtonStatus: this._DataHelper.getFavoritesButtonStatus(),
      liveFavoriteData: this._DataHelper.getLiveFavoriteTournamentData(),
      favoriteData: this.checkLiveFavoriMatch(this.liveMatchList),
      time: this.lastRebuildTime,
      sortType: this._DataHelper.liveMatchFilter,
    };

    if (this.liveMatchList === undefined) {
      return;
    }

    if (this.liveMatchList != undefined && this.liveMatchList.length > 0) {
      this.firstLiveEventId = this.liveMatchList[0].EventId;
    }

    const promise = this._webWorkerService
      .run(this._DataHelper.webWorkerLiveJob, wwsConfig)
      .then(result => {
        if (this.lastRebuildTime > result.time) {
          return;
        }

        this.__ResultLiveData = result.dt;
        const Obsobj = of(this.__ResultLiveData);

        this.fullmatch = Obsobj;

        this.isInitialized = true;
      })
      .catch(e => {
        // console.error(e)
      });
  }

  // upcoming data merged to liveMatchList
  mergeLiveAndUpcoming(): void {
    this.liveMatchList = [
      ...(Array.isArray(this._DataHelper.liveData) ? this._DataHelper.liveData.map(i => ({ ...i, isLive: true })) : []),
      ...(Array.isArray(this._fixtureUpcoming) ? this._fixtureUpcoming.map(i => ({ ...i, isLive: false })) : []),
    ];
    this._DataHelper.liveMatchobservable.next(this.liveMatchList);
    const _removeUniquePipe = new removeUniquePipe();
    this._DataHelper.liveSportsData = _removeUniquePipe.transform(this.liveMatchList, 'SportNameOriginal', 'SportName');
    // console.log('this._DataHelper.liveSportsData', this._DataHelper.liveSportsData);
    this.dataRebuild();
  }

  getUpcomingP1001() {
    const cachedItems = this.cacheService.getOrSetCache('items', this._ApiService.getp1001UpcomingFixture());

    cachedItems.subscribe(
      data => {
        this._fixtureUpcoming = data;
        this.mergeLiveAndUpcoming();
      },
      error => {
        console.error('Error fetching items:', error);
      }
    );
  }

  checkLiveFavoriMatch(q): number[] {
    const a = localStorage.getItem('_F');
    const favoriedList = a && JSON.parse(a);

    return favoriedList;

    if (favoriedList.length > 0) {
      for (let i = 0; i < q.length; i++) {
        for (let j = 0; j < favoriedList.length; j++) {
          if (q[i].BetradarMatchId === favoriedList[j]) {
            this._UserHelper.reBuildLiveFavoriList(q[i].BetradarMatchId);
          }
        }
      }
    }
  }

  matchFilterBySport(e) {
    this.liveFilterSelectedSportIdOld = this.liveFilterSelectedSportId;

    if (e) {
      if (e.sportName) {
        this.matchFilterBySportKey = e.sportName;
      }
      if (e.sportId) {
        this.liveFilterSelectedSportId = e.sportId;
      }
    }

    if (e.sportId != this.liveFilterSelectedSportIdOld) {
      this.getOddComboList();
      if (this.flagSportFilter) {
        this.oddComboChange(this.combo1SelectedOdd, 0);
        this.oddComboChange(this.combo2SelectedOdd, 1);
        this.oddComboChange(this.combo3SelectedOdd, 2);
        this.oddComboChange(this.combo4SelectedOdd, 3);
      }
    }

    this._liveFilterItems = [];
    this._DataHelper.setLiveFilterItems(this._liveFilterItems);
    this.flagSportFilter = true;
  }

  sportName(e) {
    if (typeof this.oddLiveMarketingValue === 'object') {
      const _a = [];
      if (this.oddLiveMarketingValue != undefined) {
        this.oddLiveMarketingValue.forEach(_y => {
          Object.prototype.hasOwnProperty.call(this.oddTypes[_y], e) ? _a.push(e) : _a.push('all');
        });
      }
      return _a;
    } else if (typeof this.oddLiveMarketingValue === 'string' || typeof this.oddLiveMarketingValue === 'number') {
      return Object.prototype.hasOwnProperty.call(this.oddTypes[this.oddLiveMarketingValue], e) ? [e] : ['all'];
    }
  }

  // Live da biten maçları Favoriden Temizleme
  clearFavourites() {
    this._DataHelper.liveFavoriteTournamentList.forEach(f => {
      const filter = this.liveMatchList.filter(x => x.TournamentId == f);
      if (filter.length == 0) {
        const index = this._DataHelper.liveFavoriteTournamentList.indexOf(f);
        this._DataHelper.liveFavoriteTournamentList.splice(index, 1);
        this._DataHelper.setFavoritesButtonStatus(false);
      }
    });
  }

  ngOnDestroy() {
    this.clearFavourites();

    // Favourites Button Status Clean
    this._DataHelper.setFavoritesButtonStatus(false);

    // League Filter Clean ( Local Storage )
    localStorage.setItem('league-filter-data', JSON.stringify([]));

    try {
      if (this.liveSubscription != undefined) {
        this.liveSubscription.unsubscribe();
      }
      if (this.liveFilterSubscription != undefined) {
        this.liveFilterSubscription.unsubscribe();
      }
      if (this.liveCardSubscription != undefined) {
        this.liveCardSubscription.unsubscribe();
      }
    } catch (e) {
      console.log(e);
    }

    for (const subscription of this.subscriptionsToStopOnDestroy) {
      if (subscription) {
        subscription.unsubscribe();
      }
    }
    if (this.timerMySlipApiCall) {
      clearInterval(this.timerMySlipApiCall);
    }

    this.liveMatchFilterAction.cancel();

    this._LiveStreamService.setIsOnTvButton(false);

    this._DataHelper.isMySlipButton = false;
  }

  liveMatchFilterAction = debounce(
    (selection: 'time' | 'league'): void => {
      this._DataHelper.liveMatchFilter = selection;
      this._DataHelper.liveMatchFilterListener.emit(selection);
    },
    1000,
    { leading: true }
  );

  oddComboChange(oddMarket, index) {
    const newOddMarket: number[] = Array.from(this.oddLiveMarketingp1001Value);
    newOddMarket[index] = oddMarket.OddId;
    this.oddLiveMarketingp1001Value = newOddMarket;
    this.dataRebuild();
  }

  getOddComboList() {
    if (this.liveFilterSelectedSportId == 2) {
      this.getBasketballComboList();
      this.oddLiveMarketingp1001Value = this.oddLiveMarketingBasketball;
      this.dataRebuild();
      return;
    } else if (this.liveFilterSelectedSportId == 3) {
      this.getBaseballComboList();
      this.oddLiveMarketingp1001Value = this.oddLiveMarketingBaseball;
      this.dataRebuild();
      return;
    } else if (this.liveFilterSelectedSportId == 4) {
      this.getIceHockeyComboList();
      this.oddLiveMarketingp1001Value = this.oddLiveMarketingIceHockey;
      this.dataRebuild();
      return;
    } else if (this.liveFilterSelectedSportId == 5) {
      this.getTennisComboList();
      this.oddLiveMarketingp1001Value = this.oddLiveMarketingTennis;
      this.dataRebuild();
      return;
    } else if (this.liveFilterSelectedSportId == 6) {
      this.getHandballballComboList();
      this.oddLiveMarketingp1001Value = this.oddLiveMarketingHandball;
      this.dataRebuild();
      return;
    } else if (this.liveFilterSelectedSportId == 17) {
      this.getTableTennisComboList();
      this.oddLiveMarketingp1001Value = this.oddLiveMarketingTableTennis;
      this.dataRebuild();
      return;
    } else if (this.liveFilterSelectedSportId == 20) {
      this.getVolleyballComboList();
      this.oddLiveMarketingp1001Value = this.oddLiveMarketingVolleyball;
      this.dataRebuild();
      return;
    } else if (this.liveFilterSelectedSportId == 14) {
      this.getAmericanFootballComboList();
      this.oddLiveMarketingp1001Value = this.oddLiveMarketingTennis;
      this.dataRebuild();
      return;
    }
    //Rugby
    else if (this.liveFilterSelectedSportId == 10) {
      this.getRugbyComboList();
      this.oddLiveMarketingp1001Value = this.oddLiveMarketingTennis;
      this.dataRebuild();
      return;
    }

    this.oddComboList = [
      { OddId: 0, OddNameLong: 'tipp_long', OddNameLong2: '', OddName: 'tipp', OddTitles: this.getOddTitles(this.liveFilterSelectedSportId) },
      { OddId: 9, OddNameLong: 'RestofMatch', OddNameLong2: '', OddName: 'RoM', OddTitles: this.getOddTitles(this.liveFilterSelectedSportId) },
      { OddId: 8, OddNameLong: 'NextGoal', OddNameLong2: '', OddName: 'NT', OddTitles: ['1', 'X', '2'] },
      { OddId: 10, OddNameLong: 'O/U_long', OddNameLong2: '', OddName: 'O/U', OddTitles: ['', '+', '-'] },
      { OddId: 22, OddNameLong: 'handicap', OddNameLong2: '', OddName: 'hc', OddTitles: ['', '1', 'X', '2'] },
      { OddId: 23, OddNameLong: 'DoppelteChance', OddNameLong2: '', OddName: 'DC', OddTitles: ['1X', '12', 'X2'] },
      { OddId: 24, OddNameLong: 'Treffenbeide?', OddNameLong2: '', OddName: 'TF?', OddTitles: ['Y', 'N'] },
      { OddId: 11, OddNameLong: 'HTFirstHalf', OddNameLong2: '', OddName: '1x2 HT', OddTitles: this.getOddTitles(this.liveFilterSelectedSportId) },
      { OddId: 12, OddNameLong: 'NT_HZ_long', OddNameLong2: '', OddName: 'NT_HZ', OddTitles: this.getOddTitles(this.liveFilterSelectedSportId) },
      { OddId: 13, OddNameLong: 'RoM HT', OddNameLong2: '', OddName: 'RoM HT', OddTitles: this.getOddTitles(this.liveFilterSelectedSportId) },
      { OddId: 14, OddNameLong: 'Ü/U 1.HZ_long', OddNameLong2: '', OddName: 'Ü/U 1.HZ', OddTitles: ['', '+', '-'] },
    ];
    this.getComboSelected();

    // NOTES
    // Tennis ten Soccer a geçtiğinde ; 2.Combodaki Uber/Unter Olan Combo İsmi Soccer da değişiyor.(Restzeitwette oluyor). Fakat data değişmiyor. Uber/Unter dataları geliyor.
  }

  getBasketballComboList() {
    this.oddComboList = [
      { OddId: 0, OddNameLong: '2way_long', OddNameLong2: '', OddName: '2way_short', OddTitles: ['1', '2'] },
      { OddId: 10, OddNameLong: 'O/U_basketball_long', OddNameLong2: '', OddName: 'O/U_basketball_short', OddTitles: ['', '+', '-'] },
      { OddId: 16, OddNameLong: 'HomeTotal_Long', OddNameLong2: '', OddName: 'HomeTotal_Short', OddTitles: ['', '+', '-'] },
      { OddId: 17, OddNameLong: 'AwayTotal_Long', OddNameLong2: '', OddName: 'AwayTotal_Short', OddTitles: ['', '+', '-'] },
      { OddId: 14, OddNameLong: 'Ü/U 1.HZ_long', OddNameLong2: '', OddName: 'Ü/U 1.HZ', OddTitles: ['', '+', '-'] },
      { OddId: 26, OddNameLong: 'handicap', OddNameLong2: '', OddName: 'hc', OddTitles: ['1', '2'] },
    ];
    this.getComboSelectedBasketball();
  }

  getTennisComboList() {
    this.oddComboList = [
      { OddId: 0, OddNameLong: '2way_long', OddNameLong2: '', OddName: '2way_short', OddTitles: ['1', '2'] },
      { OddId: 24, OddNameLong: 'Tie/Break_Set', OddNameLong2: '', OddName: 'TF?', OddTitles: ['Y', 'N'] },
      { OddId: 18, OddNameLong: 'TennisSet_Long', OddNameLong2: '', OddName: 'TennisSet_Short', OddTitles: ['1', '2'] },
      { OddId: 20, OddNameLong: 'TennisTotalSet_Long', OddNameLong2: '', OddName: 'TennisTotalSet_Short', OddTitles: ['1', '2'] },
    ];
    this.getComboSelectedTennis();
  }
  getAmericanFootballComboList() {
    this.oddComboList = [
      { OddId: 0, OddNameLong: '2way_long', OddNameLong2: '', OddName: 'tipp', OddTitles: this.getOddTitles(this.liveFilterSelectedSportId) },
      { OddId: 0, OddNameLong: 'RestofMatch', OddNameLong2: '', OddName: 'RoM', OddTitles: this.getOddTitles(this.liveFilterSelectedSportId) },
      { OddId: 8, OddNameLong: 'NextGoal', OddNameLong2: '', OddName: 'NT', OddTitles: ['1', 'X', '2'] },
      { OddId: 10, OddNameLong: 'O/U_long', OddNameLong2: '', OddName: 'O/U', OddTitles: ['', '+', '-'] },
      { OddId: 22, OddNameLong: 'handicap', OddNameLong2: '', OddName: 'hc', OddTitles: ['', '1', 'X', '2'] },
      { OddId: 23, OddNameLong: 'DoppelteChance', OddNameLong2: '', OddName: 'DC', OddTitles: ['1X', '12', 'X2'] },
      { OddId: 24, OddNameLong: 'Treffenbeide?', OddNameLong2: '', OddName: 'TF?', OddTitles: ['Y', 'N'] },
      { OddId: 11, OddNameLong: 'HTFirstHalf', OddNameLong2: '', OddName: '1x2 HT', OddTitles: this.getOddTitles(this.liveFilterSelectedSportId) },
      { OddId: 12, OddNameLong: 'NT_HZ_long', OddNameLong2: '', OddName: 'NT_HZ', OddTitles: this.getOddTitles(this.liveFilterSelectedSportId) },
      { OddId: 13, OddNameLong: 'RoM HT', OddNameLong2: '', OddName: 'RoM HT', OddTitles: this.getOddTitles(this.liveFilterSelectedSportId) },
      { OddId: 14, OddNameLong: 'Ü/U 1.HZ_long', OddNameLong2: '', OddName: 'Ü/U 1.HZ', OddTitles: ['', '+', '-'] },
    ];

    this.getComboSelectedAmericanFootball();
  }
  getIceHockeyComboList() {
    this.oddComboList = [
      { OddId: 0, OddNameLong: 'tipp_long', OddNameLong2: '', OddName: 'tipp', OddTitles: ['1', '2'] },
      { OddId: 9, OddNameLong: 'RestofMatch', OddNameLong2: '', OddName: 'RoM', OddTitles: this.getOddTitles(this.liveFilterSelectedSportId) },
      { OddId: 10, OddNameLong: 'O/U_long', OddNameLong2: '', OddName: 'O/U', OddTitles: ['', '+', '-'] },
      { OddId: 19, OddNameLong: 'IceHockeyPeriod_Long', OddNameLong2: '', OddName: 'IceHockeyPeriod_Short', OddTitles: ['', '+', '-'] },
    ];
    this.getComboSelectedIceHockey();
  }
  getRugbyComboList() {
    this.oddComboList = [
      { OddId: 0, OddNameLong: 'tipp_long', OddNameLong2: '', OddName: 'tipp', OddTitles: ['1', 'X', '2'] },
      { OddId: 10, OddNameLong: 'O/U_long', OddNameLong2: '', OddName: 'O/U', OddTitles: ['', '+', '-'] },
      { OddId: 22, OddNameLong: 'handicap', OddNameLong2: '', OddName: 'hc', OddTitles: ['', '1', 'X', '2'] },
    ];
    this.getComboSelectedRugby();
  }

  getVolleyballComboList() {
    this.oddComboList = [
      { OddId: 0, OddNameLong: '2way_long', OddNameLong2: '', OddName: '2way_short', OddTitles: this.getOddTitles(this.liveFilterSelectedSportId) },
      { OddId: 10, OddNameLong: 'O/U_long', OddNameLong2: '', OddName: 'O/U', OddTitles: ['', '+', '-'] },
      { OddId: 18, OddNameLong: 'TennisSet_Long', OddNameLong2: '', OddName: 'TennisSet_Short', OddTitles: ['1', '2'] },
      // { OddId: 21, OddNameLong: 'TennisTotalSet_Long', OddNameLong2: '', OddName: 'TennisTotalSet_Short', OddTitles: ['1', 'X', '2'] },
    ];
    this.getComboSelectedVolleyball();
  }

  getHandballballComboList() {
    this.oddComboList = [
      { OddId: 0, OddNameLong: 'tipp_long', OddNameLong2: '', OddName: 'tipp', OddTitles: this.getOddTitles(this.liveFilterSelectedSportId) },
      { OddId: 9, OddNameLong: 'RestofMatch', OddNameLong2: '', OddName: 'RoM', OddTitles: this.getOddTitles(this.liveFilterSelectedSportId) },
      { OddId: 10, OddNameLong: 'O/U_long', OddNameLong2: '', OddName: 'O/U', OddTitles: ['', '+', '-'] },
      { OddId: 11, OddNameLong: 'HTFirstHalf', OddNameLong2: '', OddName: '1x2 HT', OddTitles: this.getOddTitles(this.liveFilterSelectedSportId) },
    ];
    this.getComboSelectedHandball();
  }

  getTableTennisComboList() {
    this.oddComboList = [
      { OddId: 0, OddNameLong: '2way_long', OddNameLong2: '', OddName: '2way_short', OddTitles: ['1', '2'] },
      { OddId: 9, OddNameLong: 'RestofMatch', OddNameLong2: '', OddName: 'RoM', OddTitles: this.getOddTitles(this.liveFilterSelectedSportId) },
      { OddId: 10, OddNameLong: 'O/U_long', OddNameLong2: '', OddName: 'O/U', OddTitles: ['', '+', '-'] },
      { OddId: 18, OddNameLong: 'TennisSet_Long', OddNameLong2: '', OddName: 'TennisSet_Short', OddTitles: ['1', '2'] },
    ];
    this.getComboSelectedTableTennis();
  }

  getBaseballComboList() {
    this.oddComboList = [
      { OddId: 0, OddNameLong: 'tipp_long', OddNameLong2: '', OddName: 'tipp', OddTitles: ['1', '2'] },
      { OddId: 10, OddNameLong: 'O/U_basketball_long', OddNameLong2: '', OddName: 'O/U_basketball_short', OddTitles: ['', '+', '-'] },
      { OddId: 16, OddNameLong: 'HomeTotal_Long', OddNameLong2: '', OddName: 'HomeTotal_Short', OddTitles: ['', '+', '-'] },
      { OddId: 17, OddNameLong: 'AwayTotal_Long', OddNameLong2: '', OddName: 'AwayTotal_Short', OddTitles: ['', '+', '-'] },
    ];
    this.getComboSelectedBaseball();
  }

  getComboSelected() {
    this.combo1SelectedOdd = this.oddComboList.find(combo => combo.OddId == 0);
    this.combo2SelectedOdd = this.oddComboList.find(combo => combo.OddId == 9);
    this.combo3SelectedOdd = this.oddComboList.find(combo => combo.OddId == 8);
    this.combo4SelectedOdd = this.oddComboList.find(combo => combo.OddId == 24);

    this._DataHelper.comboSelectedOdd = this.combo1SelectedOdd;
  }

  getComboSelectedBasketball() {
    this.combo1SelectedOdd = this.oddComboList.find(combo => combo.OddId == 0);
    this.combo2SelectedOdd = this.oddComboList.find(combo => combo.OddId == 10);
    this.combo3SelectedOdd = this.oddComboList.find(combo => combo.OddId == 16);
    this.combo4SelectedOdd = this.oddComboList.find(combo => combo.OddId == 17);

    this._DataHelper.comboSelectedOdd = this.combo1SelectedOdd;
  }

  getComboSelectedBaseball() {
    this.combo1SelectedOdd = this.oddComboList.find(combo => combo.OddId == 0);
    this.combo2SelectedOdd = this.oddComboList.find(combo => combo.OddId == 10);
    this.combo3SelectedOdd = this.oddComboList.find(combo => combo.OddId == 16);
    this.combo4SelectedOdd = this.oddComboList.find(combo => combo.OddId == 17);

    this._DataHelper.comboSelectedOdd = this.combo1SelectedOdd;
  }

  getComboSelectedTennis() {
    this.combo1SelectedOdd = this.oddComboList.find(combo => combo.OddId == 0);
    this.combo2SelectedOdd = this.oddComboList.find(combo => combo.OddId == 24);
    this.combo3SelectedOdd = this.oddComboList.find(combo => combo.OddId == 18);
    this.combo4SelectedOdd = this.oddComboList.find(combo => combo.OddId == 20);

    this._DataHelper.comboSelectedOdd = this.combo1SelectedOdd;
  }
  getComboSelectedAmericanFootball() {
    this.combo1SelectedOdd = this.oddComboList.find(combo => combo.OddId == 0);
    this.combo2SelectedOdd = this.oddComboList.find(combo => combo.OddId == 10);
    this.combo3SelectedOdd = this.oddComboList.find(combo => combo.OddId == 8);
    this.combo4SelectedOdd = this.oddComboList.find(combo => combo.OddId == 24);

    this._DataHelper.comboSelectedOdd = this.combo1SelectedOdd;
  }

  getComboSelectedIceHockey() {
    this.combo1SelectedOdd = this.oddComboList.find(combo => combo.OddId == 0);
    this.combo2SelectedOdd = this.oddComboList.find(combo => combo.OddId == 9);
    this.combo3SelectedOdd = this.oddComboList.find(combo => combo.OddId == 10);
    this.combo4SelectedOdd = this.oddComboList.find(combo => combo.OddId == 19);

    this._DataHelper.comboSelectedOdd = this.combo1SelectedOdd;
  }
  getComboSelectedRugby() {
    this.combo1SelectedOdd = this.oddComboList.find(combo => combo.OddId == 0);
    this.combo2SelectedOdd = this.oddComboList.find(combo => combo.OddId == 10);
    this.combo3SelectedOdd = this.oddComboList.find(combo => combo.OddId == 22);

    this._DataHelper.comboSelectedOdd = this.combo1SelectedOdd;
  }

  getComboSelectedVolleyball() {
    this.combo1SelectedOdd = this.oddComboList.find(combo => combo.OddId == 0);
    this.combo2SelectedOdd = this.oddComboList.find(combo => combo.OddId == 10);
    this.combo3SelectedOdd = this.oddComboList.find(combo => combo.OddId == 18);
    // this.combo4SelectedOdd = this.oddComboList.find(combo => combo.OddId == 21);

    this._DataHelper.comboSelectedOdd = this.combo1SelectedOdd;
  }

  getComboSelectedHandball() {
    this.combo1SelectedOdd = this.oddComboList.find(combo => combo.OddId == 0);
    this.combo2SelectedOdd = this.oddComboList.find(combo => combo.OddId == 9);
    this.combo3SelectedOdd = this.oddComboList.find(combo => combo.OddId == 10);
    this.combo4SelectedOdd = this.oddComboList.find(combo => combo.OddId == 11);

    this._DataHelper.comboSelectedOdd = this.combo1SelectedOdd;
  }

  getComboSelectedTableTennis() {
    this.combo1SelectedOdd = this.oddComboList.find(combo => combo.OddId == 0);
    this.combo2SelectedOdd = this.oddComboList.find(combo => combo.OddId == 9);
    this.combo3SelectedOdd = this.oddComboList.find(combo => combo.OddId == 10);
    this.combo4SelectedOdd = this.oddComboList.find(combo => combo.OddId == 18);

    this._DataHelper.comboSelectedOdd = this.combo1SelectedOdd;
  }

  getOddTitles(id: number) {
    if (id == 2 || id == 5 || id == 20 || id == 14) {
      return ['1', '2'];
    } else {
      return ['1', 'X', '2'];
    }
  }

  oddBoxClick(oddMarket, index) {
    this.combo1SelectedOdd = oddMarket;
    this._DataHelper.comboSelectedOdd = oddMarket;

    const newOddMarket: number[] = Array.from(this.oddLiveMarketingp1001Value);
    newOddMarket[index] = oddMarket.OddId;
    this.oddLiveMarketingp1001Value = newOddMarket;
  }
  StandartSingleChange(id) {
    this.standartSingleId = id;

    if (id === 2) {
      this._Router.navigate(['/liveeventdetail', this.firstLiveEventId]);
    }
  }

  oddFilterToggle() {
    this.oddFilterIsActive = !this.oddFilterIsActive;
  }

  getResponsiveOddShow(indexOddOrder) {
    switch (indexOddOrder) {
      case 1:
        return this._UiHelper.isResponsiveRules(['s']);
      case 2:
        return this._UiHelper.isResponsiveRules(['xl']);
      case 3:
        return this._UiHelper.isResponsiveRules(['xxl']);
      default:
        return true;
    }
  }
}

export class OddModel {
  constructor(OddId: number, OddName: string, OddTitles: []) {
    this.OddId = OddId;
    this.OddName = OddName;
    this.OddTitles = OddTitles;
  }

  OddId: number;
  OddName: string;
  OddTitles: string[];
}

export class LiveOddComboModel {
  constructor(OddId: number, OddName: string, OddNameLong: string, OddNameLong2: string, OddTitles: []) {
    this.OddId = OddId;
    this.OddName = OddName;
    this.OddTitles = OddTitles;
    this.OddNameLong = OddNameLong;
    this.OddNameLong2 = OddNameLong2;
  }

  OddId: number;
  OddName: string;
  OddTitles: string[];
  OddNameLong: string;
  OddNameLong2: string;
}
